"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hex2rgb = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
        : null;
};
// Inverse of the above
exports.rgb2hex = function (rgb) {
    // tslint:disable-next-line:no-bitwise
    return '#' + ((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1);
};
function _interpolateColor(color1, color2, factor) {
    var result = color1.slice();
    for (var i = 0; i < 3; i++) {
        result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
    }
    return result;
}
exports.genColorsArray = function (color1, color2, steps) {
    if (steps === 1) {
        return [exports.rgb2hex(color1)];
    }
    var factorStep = 1 / (steps - 1);
    var colors = [];
    for (var i = 0; i < steps; i++) {
        var color = _interpolateColor(color1, color2, factorStep * i);
        colors.push(exports.rgb2hex(color));
    }
    return colors;
};
exports.default = (function (tone, steps) {
    switch (tone.toLowerCase()) {
        case 'purple':
            return exports.genColorsArray(exports.hex2rgb('#9B59B6'), exports.hex2rgb('#EBDEF0'), steps);
        case 'red':
            return exports.genColorsArray(exports.hex2rgb('#EE3124'), exports.hex2rgb('#FBD5D3'), steps);
        case 'orange':
            return exports.genColorsArray(exports.hex2rgb('#F37021'), exports.hex2rgb('#FDE2D3'), steps);
        case 'yellow':
            return exports.genColorsArray(exports.hex2rgb('#FFC627'), exports.hex2rgb('#FFF4D4'), steps);
        case 'green':
            return exports.genColorsArray(exports.hex2rgb('#7EB338'), exports.hex2rgb('#E5F0D7'), steps);
        case 'blue':
        default:
            return exports.genColorsArray(exports.hex2rgb('#1792E5'), exports.hex2rgb('#D1E9FA'), steps);
    }
});
//# sourceMappingURL=genColorsByTone.js.map